import styled from '@emotion/styled'
import { Box } from '@mui/material'
import { theme } from '../../themes/theme'

const ProgressBarWrapper = styled(Box)`
  align-content: center;
  width: 100%;

  .MuiLinearProgress-root {
    background-color: ${theme.colors.primaryLight};
  }

  .MuiLinearProgress-bar1 {
    background-color: ${theme.colors.primary};
  }
`

export { ProgressBarWrapper }
